import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Sparkline } from "./Sparkline";
import { ChangePill } from "./ChangePill";
import { useHistory } from "../hooks/useMarket";
import { formatPrice } from "../lib/format";
import { pathFor } from "../lib/assets";

export function MarketCard({ asset }) {
  const { t, i18n } = useTranslation();
  const { data } = useHistory(asset.symbol, "7D");
  const series = (data?.series || []).map((p) => p.price);
  const up = asset.change24h >= 0;
  const name = t(`nav.${asset.symbol}`, { defaultValue: asset.name });

  return (
    <Link
      to={pathFor(asset.symbol)}
      data-testid={`market-card-${asset.symbol}`}
      className="group flex flex-col justify-between rounded-lg border border-border bg-card p-5 transition-[border-color,transform] duration-200 hover:-translate-y-px hover:border-primary/40"
    >
      <div className="flex items-start justify-between">
        <div>
          <div className="font-heading text-lg leading-tight text-foreground">{name}</div>
          <div className="text-[10px] font-medium uppercase tracking-[0.2em] text-muted-foreground">
            {t(`common.${asset.category === "metal" ? "metals" : asset.category === "crypto" ? "cryptocurrencies" : asset.category}`, { defaultValue: asset.category })}
          </div>
        </div>
        <div className="h-9 w-20 opacity-80">
          <Sparkline data={series} up={up} height={36} />
        </div>
      </div>
      <div className="mt-4 flex items-end justify-between">
        <div className="num text-xl font-semibold tracking-tight text-foreground">
          {formatPrice(asset.price, asset.quoteCurrency, i18n.language)}
        </div>
        <ChangePill value={asset.change24h} />
      </div>
    </Link>
  );
}
